import React from "react";
import { Link } from "react-router-dom";

// const menuItems = [
//     // {
//     //   label: "Create Company",
//     //   icon: "fa-regular fa-plus",
//     //   link: "/manage-company",
//     // },

//     {
//         label: "Jobs",
//         icon: "fa-fw fa-solid fa-briefcase",
//         link: "/jobs-list",
//     },
//     {
//         label: "Applications",
//         icon: "fa-regular fa-newspaper",
//         link: "/applications",
//     },
//     { label: "Saved Jobs", icon: "fa-regular fa-bookmark", link: "/saved-jobs" },
// ];

const MenuCard = ({
  organization,
  loading = false,
  width = "full",
  className = "",
  itemClass = "",
}) => {
  if (loading) {
    return (
      <div
        className={`${width} bg-white rounded-lg shadow-md border border-gray-200 p-2 ${className}`}
      >
        {[1, 2, 3].map((_, index) => (
          <div
            key={index}
            className="flex items-center gap-3 px-3 py-2 animate-pulse"
          >
            <div className="w-5 h-5 bg-gray-200 rounded"></div>
            <div className="h-3 w-24 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const menuItems = organization
    ? [
        {
          label: "Posted Jobs",
          icon: "fa-fw fa-solid fa-briefcase",
          link: "/jobs-list",
        },
        {
          label: "Applications",
          icon: "fa-regular fa-newspaper",
          link: "/applications",
        },
        {
          label: "Company Inbox",
          icon: "fa-regular fa-envelope",
          link: "/inbox",
        },
        {
          label: "Saved Jobs",
          icon: "fa-regular fa-bookmark",
          link: "/saved-jobs",
        },
      ]
    : [
        // {
        //   label: "Applied Jobs",
        //   icon: "fa-regular fa-newspaper",
        //   link: "/applications",
        // },
        {
          label: "Saved Jobs",
          icon: "fa-regular fa-bookmark",
          link: "/saved-jobs",
        },
      ];

  return (
    <div
      className={`${width} bg-white rounded-lg  border border-zinc-200 p-2 ${className}`}
    >
      {menuItems?.map((item, index) => {
        const Content = (
          <div
            onClick={item.onClick}
            className={`flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 cursor-pointer transition ${itemClass}`}
          >
            {item.icon && (
              <div className="w-5 flex justify-center">
                <i className={`${item.icon} text-gray-700 text-sm`} />
              </div>
            )}
            <span className="text-gray-900 font-medium text-sm">
              {item.label}
            </span>
          </div>
        );

        return item.link ? (
          <Link key={index} to={item.link}>
            {Content}
          </Link>
        ) : (
          <div key={index}>{Content}</div>
        );
      })}
    </div>
  );
};

export default MenuCard;
